export { default as LifeShineLogo } from './lifeshine-logo.svg'
